import { render, staticRenderFns } from "./BmvBadge.vue?vue&type=template&id=79e563ce&scoped=true"
import script from "./BmvBadge.vue?vue&type=script&lang=js"
export * from "./BmvBadge.vue?vue&type=script&lang=js"
import style0 from "./BmvBadge.vue?vue&type=style&index=0&id=79e563ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e563ce",
  null
  
)

export default component.exports